import styled, { css, keyframes } from 'styled-components';

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

const pulse = keyframes`
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
`;

const bounce = keyframes`
    0%, 80%, 100% {
        transform: scale(0);
    }
    40% {
        transform: scale(1);
    }
`;

export const SpinnerWrapper = styled.div<{ $global?: boolean; $containerHeight?: string }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: ${(props) => props.$containerHeight || '100%'};
    ${(props) => props.$global && css`
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: ${props.theme.mode === 'dark' ? 'rgba(26, 31, 38, 0.95)' : 'rgba(255, 255, 255, 0.95)'};
        backdrop-filter: blur(4px);
        z-index: 9999;
    `}
`;

export const SpinnerCircle = styled.div<{ $size: 'sm' | 'md' | 'lg'; $variant: string }>`
    ${(props) => {
    const sizeMap = {
      sm: '16px',
      md: '40px',
      lg: '56px',
    };
    const borderWidth = {
      sm: '2px',
      md: '3px',
      lg: '4px',
    };
    const borderColor = props.theme.mode === 'dark' ? '#374151' : '#dcdfe4';

    return css`
            width: ${sizeMap[props.$size]};
            height: ${sizeMap[props.$size]};
            border: ${borderWidth[props.$size]} solid ${borderColor};
            border-top-color: #1a4d4d;
            border-radius: 50%;
            animation: ${spin} 0.8s linear infinite;
        `;
  }}
`;

export const DotsWrapper = styled.div<{ $size: 'sm' | 'md' | 'lg' }>`
    display: flex;  
    gap: ${(props) => (
    // eslint-disable-next-line no-nested-ternary
    props.$size === 'sm' ? '6px'
      : props.$size === 'md' ? '8px' : '6px')};
`;

export const Dot = styled.div<{ $size: 'sm' | 'md' | 'lg'; $delay: number }>`
    ${(props) => {
    const sizeMap = {
      sm: '8px',
      md: '12px',
      lg: '16px',
    };

    return css`
            width: ${sizeMap[props.$size]};
            height: ${sizeMap[props.$size]};
            background: #1a4d4d;
            border-radius: 50%;
            animation: ${bounce} 1.4s infinite ease-in-out both;
            animation-delay: ${props.$delay}s;
        `;
  }}
`;

export const PulseCircle = styled.div<{ $size: 'sm' | 'md' | 'lg' }>`
    ${(props) => {
    const sizeMap = {
      sm: '24px',
      md: '40px',
      lg: '56px',
    };

    return css`
            width: ${sizeMap[props.$size]};
            height: ${sizeMap[props.$size]};
            background: #1a4d4d;
            border-radius: 50%;
            animation: ${pulse} 1.2s ease-in-out infinite;
        `;
  }}
`;

export const SpinnerLabel = styled.p`
    margin-top: 16px;
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.text.secondary};
    text-align: center;
`;
